import React from "react";

const Metrics = ({ items }) => {
  return (
    <section className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {items.map((m, i) => (
        <div key={i} className="rounded-2xl p-6 bg-[#FFF5F2] border border-[#E85D44]/20 shadow-lg hover:shadow-xl transition-shadow">
          <div className="text-3xl font-extrabold text-[#E85D44]">{m.value}</div>
          <div className="text-sm mt-1 text-gray-600">{m.label}</div>
        </div>
      ))}
    </section>
  );
};

export default Metrics;

